import { Fragment } from 'react';

import { Transition } from '@headlessui/react';

interface Props {
  show: boolean;
  onClose?: () => void;
  children?: React.ReactElement<any> | number | string;
}

const GatedModal = ({ children, show }: Props) => {
  return (
    <Transition show={show} as={Fragment}>
      <Transition.Child
        as={Fragment}
        enter="ease-out duration-100"
        enterFrom="transform translate-y-3/4 opacity-0"
        enterTo="transform translate-y-0 opacity-100"
        leave="ease-in duration-100"
        leaveFrom="transform translate-y-0 opacity-100"
        leaveTo="transform translate-y-3/4 opacity-0"
      >
        <div className="fixed bottom-0 left-0 z-40 flex h-3/4 min-h-[475px] w-full items-end sm:items-center">
          <div className="relative mx-auto flex h-full w-full max-w-none transform items-center justify-center overflow-auto rounded-t-wt bg-gradient-to-t from-[var(--wt-background-color)] from-80% p-4 text-left align-middle transition-all md:from-70%">
            <div className="relative flex h-full w-full flex-col items-center justify-end space-y-4 pt-20">
              {children}
            </div>
          </div>
        </div>
      </Transition.Child>
    </Transition>
  );
};

export default GatedModal;
